import { useMutation, useQueryClient } from 'react-query';
import axios from '../../../utils/axios';
import { apiurl } from '../../../config/apiUrl';

const deleteFixedBudgetVesselAccCodesQuery = (fixedBudgetVesselAccCodeIds) => {
  return axios.post(apiurl?.deleteFixedBudgetVesselAccCode, { fixedBudgetVesselAccCodeIds });
};

const deleteFixedBudgetVesselAccCodes = () => {
  const queryClient = useQueryClient();
  return useMutation(deleteFixedBudgetVesselAccCodesQuery, {
    onSuccess: () => {
      queryClient.invalidateQueries('getFixedBudgetVesselAccCodeList');
    }
  });
};

export default deleteFixedBudgetVesselAccCodes;
